import { CalendarEventDetails, CalendarEventRef } from '@griply/types';
import {
  ExternalCalendarEventSanitizer,
  sanitizeCalendarEventDetails,
} from '@griply/utils';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type GetExternalCalendarEventPayload = CalendarEventRef;

// Provider-authored data: only the sanitizer turns it into a CalendarEventDetails.
type GetExternalCalendarEventResult = {
  event: unknown;
  contractVersion?: number;
};

export type GetExternalCalendarEventOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: GetExternalCalendarEventPayload;
  sanitizeDetails?: ExternalCalendarEventSanitizer['sanitizeDetails'];
};

export const getExternalCalendarEvent = async <TFunctions>(
  options: GetExternalCalendarEventOptions<TFunctions>,
): Promise<CalendarEventDetails | null> => {
  const {
    functions,
    httpsCallable,
    payload,
    sanitizeDetails = sanitizeCalendarEventDetails,
  } = options;
  const callable = httpsCallable<
    GetExternalCalendarEventPayload,
    GetExternalCalendarEventResult
  >(functions, 'externalCalendars-getEvent');

  const { data } = await callable(payload);

  if (!data.event) {
    return null;
  }

  return sanitizeDetails(data.event);
};
